<template>
	<div class="u-tags flex-wrap">
		<div v-for="(item, i) in tags" :key="i" class="item">{{item}}</div>
	</div>
</template>

<script>
	export default {
		name: 'cTags',
		
		props: {
			value: [String, Array],
			split: {
				type: String,
				default: ','
			}
		},
		
		computed: {
			tags() {
				return typeof this.value == 'object' ? this.value : this.value.split(this.split) || [];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.u-tags {
		margin-left: -5px;
		margin-top: -5px;

		.item {
			border-radius: 3px;
			padding: 0 7px;
			margin-left: 5px;
			margin-top: 5px;
			line-height: 22px;
			font-size: 13px;
			color: #333;
			background: #F5F5F5;
		}
	}
</style>
